
define('text!views/ecards/ecard_group.html',[],function () { return '\r\n<a href="#merchants/groups/<%= this.data.key %>" class="block a--unstyled js-account-egiftcard">\r\n    <img src="<%= this.data.logo %>" class="ecard-merchant-logo" alt="<%= this.data.name %> Logo">\r\n    <% if(this.data.num > 1){ %>\r\n    <span class="ecard-count"><%= this.data.num %></span>\r\n    <% } %>\r\n</a>';});

